import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { cn } from '../../lib/cn';

// Przełącznik motywu jako segmentowana kontrolka z trzema stanami.
//
// Świadomie nie jest to przełącznik dwustanowy: opcja "systemowy" pozwala
// aplikacji podążać za ustawieniem systemu operacyjnego, co ma znaczenie przy
// pracy na zmianę dzienną i nocną — motyw zmienia się wtedy sam.

const OPTIONS = [
  { value: 'light', icon: Sun, label: 'Motyw jasny' },
  { value: 'dark', icon: Moon, label: 'Motyw ciemny' },
  { value: 'system', icon: Monitor, label: 'Motyw systemowy' },
];

export function ThemeToggle({ className }) {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Motyw kolorystyczny"
      className={cn('inline-flex items-center gap-0.5 rounded-md border border-line bg-elevated p-0.5', className)}
    >
      {OPTIONS.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={theme === value}
          aria-label={label}
          title={label}
          onClick={() => setTheme(value)}
          className={cn(
            'inline-flex h-6 w-6 items-center justify-center rounded transition-colors',
            theme === value
              ? 'bg-surface text-content shadow-card'
              : 'text-subtle hover:text-content'
          )}
        >
          <Icon size={13} />
        </button>
      ))}
    </div>
  );
}

export default ThemeToggle;
